
import { Vue, Component, Prop } from "vue-property-decorator";
import { globalStore } from "@/store/store-accessor";
import { ButtonPresetInputValue } from "@/types/buttons";
import NiceButton from "@/components/UI/NiceButton.vue";
import { setGlobalSettingsAccordionState } from "@/lib/panels/accordions";
import { openUiPanel } from "@/lib/panels/panels";

@Component({
  components: { NiceButton }
})
export default class ButtonPresetInput extends Vue {
  @Prop()
  value!: ButtonPresetInputValue;

  get presetsForDropdown() {
    return this.globalPresets.map(x => ({
      text: x.name,
      value: x.id
    }));
  }

  get globalPresets() {
    return (globalStore.buttonPresets || []).filter(p => p.name && p.id);
  }

  updatePreset(value: ButtonPresetInputValue) {
    if (value) {
      this.$emit("input", value);
    } else {
      this.$emit("input", null);
    }
  }

  managePresets() {
    setGlobalSettingsAccordionState("settings.buttons", true);
    openUiPanel("globalSettings");

    // Toggle off and on to make sure the accordion is open on second click.
    setGlobalSettingsAccordionState("settings.buttons.button_presets", false);

    this.$nextTick(() => {
      setGlobalSettingsAccordionState("settings.buttons.button_presets", true);
    });
  }
}
